export enum RosterActionOption {
    MESSAGE,
    ADD_EVENT_NOTE,
    CHANGE_PURCHASE_ARRIVAL,
    CHANGE_EVENT_ARRIVAL,
    CANCEL_BOOKING,
    EMAIL_ROSTER,
    EXPORT_ROSTER,
    ADJUST_CAPACITY,
    PRINT_ROSTER,
    EVENT_NOTES,
    JOIN_WAITLIST,
    DELETE_EVENT,
    MAKE_PURCHASE,
    UNASSIGN_GUIDE,
    ASSIGN_GUIDE,
    EDIT_EQUIPMENT,
    OPEN_ROSTER,
}
